import { useTranslation } from "next-i18next";
import { useState, useEffect } from "react";
import { useRouter } from "next/router";
import Icon from "@/components/Icon";

/**
 * 搜索输入框
 * @returns
 */
const SearchInput = ({ isMobile = false }, { isMobile: boolean }) => {
  const { t } = useTranslation();
  const router = useRouter();
  const [keyword, setKeyword] = useState<string>((router.query.keyword as string) || "");
  const [isFocus, setIsFocus] = useState<boolean>(false);

  /**
   * input change
   * @param e
   */
  const onChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    let value = e.target.value;
    if (value && value.length > 17) {
      value = value.substring(0, 17);
    }
    setKeyword(value);
  };

  /**
   * input keyup
   * @param e
   */
  const onKeyUp = (e: React.KeyboardEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    if (e && e.keyCode && e.keyCode === 13) {
      handleGoMall();
    }
  };

  /**
   * go to mall
   */
  const handleGoMall = () => {
    router.push(`/mall?keyword=${keyword}`);
  };

  useEffect(() => {
    setKeyword((router.query.keyword as string) || "");
  }, [router.query.keyword]);

  return (
    <div
      className={`relative h-10 w-full px-mobile lg:h-12 lg:w-42 lg:px-0 ${
        !isMobile ? "hidden lg:block" : "block lg:hidden"
      }`}
    >
      <input
        type="text"
        className={`static left-0 top-0 h-full w-full rounded-none border-b-2 border-gray-600 bg-transparent pl-8 pr-6 outline-none transition-all placeholder:text-stone-100 hover:border-primary focus:outline-none active:outline-none lg:absolute lg:pl-0 ${
          isFocus ? "border-primary" : ""
        }`}
        placeholder={!isFocus ? t("common.input_placeholder") : ""}
        value={keyword}
        onChange={onChange}
        onKeyUp={onKeyUp}
        onFocus={() => {
          setIsFocus(true);
        }}
        onBlur={() => {
          setIsFocus(false);
        }}
      />
      {keyword && (
        <Icon
          name="input-close"
          size={16}
          title="icon input close"
          className="absolute right-mobile top-[10px] z-10 cursor-pointer lg:right-6 lg:top-4"
          onClick={() => {
            setKeyword("");
          }}
          data-qt="header_search_clear"
        />
      )}

      <Icon
        name="search"
        size={20}
        title="icon search"
        className="absolute left-mobile right-auto top-3 z-10 cursor-pointer lg:left-auto lg:right-0 lg:top-14px"
        onClick={handleGoMall}
        data-qt="header_search_submit"
        data-qt-keyword={keyword}
      />
    </div>
  );
};

export default SearchInput;